/**
 * Step hierarchy and the associated ids.
 */
export const STEP_PATHS = {
  info: { id: 'info' },
  specialPages: { id: 'specialPages' },
  editWebsite: {
    id: 'editWebsite',
    pickEdit: { id: 'editWebsite.pickEdit' },
    pickPlatform: { id: 'editWebsite.pickPlatform' },
  },
  tag: {
    id: 'tag',
    emailTag: { id: 'tag.emailTag' },
    thirdPartyTag: { id: 'tag.thirdPartyTag' },
    copyTag: { id: 'tag.copyTag' },
    googleTagManager: { id: 'tag.googleTagManager' },
  },
};
